import { render, staticRenderFns } from "./OwnerKeysResultComponent.vue?vue&type=template&id=36e15328"
import script from "./OwnerKeysResultComponent.vue?vue&type=script&lang=js"
export * from "./OwnerKeysResultComponent.vue?vue&type=script&lang=js"
import style0 from "./OwnerKeysResultComponent.vue?vue&type=style&index=0&id=36e15328&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports